import { render, staticRenderFns } from "./FormElementRadioButton.vue?vue&type=template&id=a492e020"
import script from "./FormElementRadioButton.vue?vue&type=script&lang=js"
export * from "./FormElementRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports